import React from 'react';
import { Tooltip } from '@shared/components/Tooltip';
import ActivateIcon from '@/assets/svg/activate.svg';
import DeactivateIcon from '@/assets/svg/deactivate.svg';

export const AdminStatusSwitchIcon: React.FC<{ isActivating: boolean }> = ({
  isActivating,
}) => {
  const Icon = isActivating ? ActivateIcon : DeactivateIcon;
  return <Icon />;
};

export const AdminStatusDescription: React.FC<{
  userName: string;
  isActivating: boolean;
}> = ({ userName, isActivating }) => {
  const shouldTruncate = userName.length > 40;
  const prefix = isActivating
    ? 'Spowoduje to natychmiastowe przywrócenie dostępu do systemu Pozytron dla użytkownika '
    : 'Spowoduje to natychmiastowe zablokowanie dostępu do systemu Pozytron dla użytkownika ';
  const suffix = isActivating
    ? 'Czy na pewno chcesz aktywować tego administratora?'
    : 'Czy na pewno chcesz dezaktywować tego administratora?';

  return (
    <>
      <span>{prefix}</span>
      {shouldTruncate ? (
        <Tooltip content={userName} align="right">
          <span
            className="inline-block overflow-hidden font-medium text-ellipsis whitespace-nowrap"
            style={{
              fontFamily: 'Roboto, sans-serif',
              fontWeight: 500,
              maxWidth: '200px',
              display: 'inline-block',
              verticalAlign: 'baseline',
            }}
          >
            {userName}.
          </span>
        </Tooltip>
      ) : (
        <span
          className="font-medium"
          style={{
            fontFamily: 'Roboto, sans-serif',
            fontWeight: 500,
          }}
        >
          {userName}.
        </span>
      )}{' '}
      <span>{suffix}</span>
    </>
  );
};
